/* LGND Product Story v3 · scroll stage, build picker, giveaway variant cards, close-up tour, countdown, count-ups.
   Loads after lgnd-story.js. One shared "current build" keeps the stage, giveaway cards and buy box in sync. */
(function () {
  if (window.__lgndStoryV2) return;
  window.__lgndStoryV2 = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var phone = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };

  function fmt(n) { n = parseInt(n, 10); return isNaN(n) ? '' : n.toLocaleString('en-US'); }
  function mainSection() {
    var picker = document.querySelector('variant-picker[context="main_product"]');
    return (picker && picker.closest('.shopify-section')) || document.querySelector('.shopify-section[id$="__main"]');
  }
  function scrollToEl(el) {
    if (!el) return;
    var header = document.querySelector('.shopify-section--header, header');
    var offset = header ? Math.min(header.getBoundingClientRect().height, 120) : 0;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - offset - 8, behavior: reduce ? 'auto' : 'smooth' });
  }
  function mainInputs() { return document.querySelectorAll('variant-picker[context="main_product"] input[type="radio"]'); }

  /* Hold the page still while the theme reacts to a variant change (it likes to scroll to the gallery/inputs). */
  function holdScroll(ms) {
    var y = window.pageYOffset, until = Date.now() + (ms || 900);
    (function guard() {
      if (Math.abs(window.pageYOffset - y) > 2) window.scrollTo(0, y);
      if (Date.now() < until) requestAnimationFrame(guard);
    })();
  }
  /* Change the buy-box variant without focusing/clicking anything, so the page doesn't jump. */
  function quietSelectMain(val) {
    var input = Array.prototype.filter.call(mainInputs(), function (i) { return i.value === val; })[0];
    if (!input || input.checked) return;
    holdScroll(1000);
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  var listeners = [];
  var current = null;
  function selectBuild(val, fromMain) {
    if (!val) return;
    current = val;
    listeners.forEach(function (fn) { fn(val); });
    if (!fromMain) quietSelectMain(val);
  }

  function addToCart(val) {
    if (val) quietSelectMain(val);
    holdScroll(1200);
    setTimeout(function () {
      var btn = document.querySelector('button[type="submit"][form^="product-form-main"]') ||
                document.querySelector('form[id^="product-form-main"] button[type="submit"]');
      if (btn && !btn.disabled) btn.click(); else scrollToEl(mainSection());
    }, 450);
  }

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-ls-count'));
    if (isNaN(target)) return;
    var dec = (el.getAttribute('data-ls-count').split('.')[1] || '').length;
    var suffix = el.getAttribute('data-ls-suffix') || '';
    if (reduce) { el.textContent = (dec ? target.toFixed(dec) : fmt(target)) + suffix; return; }
    var start = null, dur = 1200;
    function step(ts) {
      if (!start) start = ts;
      var k = Math.min(1, (ts - start) / dur); k = 1 - Math.pow(1 - k, 3);
      var v = target * k;
      el.textContent = (dec ? v.toFixed(dec) : fmt(Math.round(v))) + suffix;
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function onView(els, fn) {
    if (!els.length) return;
    if (!hasIO) { els.forEach(fn); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { fn(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    document.querySelectorAll('[data-ls-num]').forEach(function (el) { el.textContent = fmt(el.getAttribute('data-ls-num')); });

    /* ---------- STAGE (scroll to open) + PICKER ---------- */
    document.querySelectorAll('[data-ls-stage]').forEach(function (stage) {
      var knife = stage.querySelector('.ls-stage__knife');
      var ghost = stage.querySelector('.ls-stage__ghost');
      var callouts = stage.querySelectorAll('[data-ls-callout]');
      var chips = stage.querySelectorAll('[data-ls-build]');
      var out = function (k) { return stage.querySelector('[data-ls-out="' + k + '"]'); };
      var atc = stage.querySelector('[data-ls-atc]');
      var atcLabel = atc ? atc.querySelector('[data-ls-out="atc"]') : null;
      var atcPrefix = atcLabel ? atcLabel.textContent.split('·')[0].trim() : 'Add to cart';
      var ent = out('entries'); if (ent) ent.textContent = fmt(ent.textContent);

      function setProgress(p) {
        var o = Math.min(1, Math.max(0, (p - 0.06) / 0.4)); o = 1 - Math.pow(1 - o, 3);
        knife.style.setProperty('--ang', (-181 * (1 - o)).toFixed(2) + 'deg');
        knife.style.setProperty('--bo', o < 0.04 ? (o / 0.04).toFixed(3) : 1);
        knife.style.setProperty('--ks', (0.9 + 0.1 * o).toFixed(3));
        if (ghost) ghost.style.setProperty('--gx', ((0.5 - p) * 18).toFixed(2) + 'vw');
        stage.classList.toggle('is-opened', p > 0.04);
        var cur = -1, m = phone.matches, c0 = m ? 0.4 : 0.46, step = m ? 0.09 : 0.05;
        callouts.forEach(function (c) {
          var i = parseInt(c.getAttribute('data-ls-callout'), 10), on = p > c0 + i * step;
          c.classList.toggle('is-on', on); if (on && i > cur) cur = i;
        });
        callouts.forEach(function (c) { c.classList.toggle('is-current', parseInt(c.getAttribute('data-ls-callout'), 10) === cur); });
        stage.classList.toggle('is-picking', p > (m ? 0.78 : 0.7));
      }
      var picker = stage.querySelector('[data-ls-picker]');
      function measure() { if (picker) stage.style.setProperty('--pk', (picker.offsetHeight + 24) + 'px'); }
      measure(); window.addEventListener('resize', measure);
      if (window.ResizeObserver && picker) new ResizeObserver(measure).observe(picker);
      if (reduce) setProgress(1);
      else {
        var ticking = false;
        var onScroll = function () {
          if (ticking) return; ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var r = stage.getBoundingClientRect(), total = stage.offsetHeight - window.innerHeight;
            setProgress(total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1);
          });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        onScroll();
      }

      listeners.push(function (val) {
        var chip = stage.querySelector('[data-ls-build="' + val + '"]'); if (!chip) return;
        chips.forEach(function (c) { var on = c === chip; c.classList.toggle('is-active', on); c.setAttribute('aria-checked', on ? 'true' : 'false'); });
        stage.querySelectorAll('[data-ls-layers]').forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-ls-layers') === val); });
        out('name').textContent = chip.getAttribute('data-name');
        out('price').textContent = chip.getAttribute('data-price');
        out('tag').textContent = chip.getAttribute('data-tag') || '';
        out('specs').innerHTML = (chip.getAttribute('data-specs') || '').split('~').filter(Boolean).map(function (s) {
          var p = s.split('|'), li = document.createElement('li'), l = document.createElement('span');
          l.textContent = (p[0] || '').trim(); li.appendChild(l); li.appendChild(document.createTextNode((p[1] || '').trim())); return li.outerHTML;
        }).join('');
        var e = chip.getAttribute('data-entries');
        out('entries-wrap').classList.toggle('is-hidden', !e);
        out('entries').textContent = fmt(e);
        var avail = chip.getAttribute('data-available') === 'true';
        if (atcLabel) atcLabel.textContent = avail ? atcPrefix + ' · ' + chip.getAttribute('data-price') : 'Sold out';
        if (atc) atc.disabled = !avail;
      });
      chips.forEach(function (c) { c.addEventListener('click', function () { selectBuild(c.getAttribute('data-ls-build')); }); });
      if (atc) atc.addEventListener('click', function () { addToCart(current); });
    });

    /* ---------- GIVEAWAY: variant photo cards + live entries ---------- */
    document.querySelectorAll('[data-ls-give]').forEach(function (give) {
      var cards = give.querySelectorAll('[data-ls-var]');
      var atc = give.querySelector('[data-ls-atc]');
      var label = give.querySelector('[data-ls-give-atc]');
      var num = give.querySelector('[data-ls-give-num]');
      var big = num ? num.parentElement : null;
      var nameEl = give.querySelector('[data-ls-give-name]');
      var prefix = atc ? atc.getAttribute('data-prefix') : 'Add to cart';
      var shown = num ? parseInt(num.getAttribute('data-ls-count'), 10) || 0 : 0, counted = false, raf = 0;
      function tweenTo(to) {
        if (!num) return;
        var from = shown; shown = to; cancelAnimationFrame(raf);
        if (reduce || !counted || from === to) { num.textContent = fmt(to); return; }
        if (big) { big.classList.remove('is-bump'); void big.offsetWidth; big.classList.add('is-bump'); }
        var start = null;
        (function step(ts) {
          if (!start) start = ts;
          var k = Math.min(1, (ts - start) / 500); k = 1 - Math.pow(1 - k, 3);
          num.textContent = fmt(Math.round(from + (to - from) * k));
          if (k < 1) raf = requestAnimationFrame(step);
        })(performance.now());
      }
      listeners.push(function (val) {
        var c = give.querySelector('[data-ls-var="' + val + '"]'); if (!c) return;
        cards.forEach(function (x) { var on = x === c; x.classList.toggle('is-active', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
        var row = c.parentElement;
        if (row && row.scrollWidth > row.clientWidth + 4) row.scrollTo({ left: c.offsetLeft - (row.clientWidth - c.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
        if (nameEl) nameEl.textContent = c.getAttribute('data-name');
        var e = parseInt(c.getAttribute('data-entries'), 10);
        if (!isNaN(e)) tweenTo(e);
        var avail = c.getAttribute('data-available') === 'true';
        if (label) label.textContent = avail ? prefix + ' · ' + c.getAttribute('data-price') : 'Sold out';
        if (atc) atc.disabled = !avail;
      });
      cards.forEach(function (c) { c.addEventListener('click', function () { selectBuild(c.getAttribute('data-ls-var')); }); });
      if (atc) atc.addEventListener('click', function () { addToCart(current); });
      onView(Array.prototype.slice.call(give.querySelectorAll('[data-ls-count]')), function (el) { countUp(el); setTimeout(function () { counted = true; }, 1250); });
    });

    /* ---------- CLOSE-UP TOUR ---------- */
    document.querySelectorAll('[data-ls-tour]').forEach(function (tour) {
      var shots = tour.querySelectorAll('[data-ls-tour-shot]');
      var texts = tour.querySelectorAll('[data-ls-tour-text]');
      var ticks = tour.querySelectorAll('[data-ls-tour-tick]');
      var n = shots.length, last = -1, preloaded = false;
      function preload() {
        if (preloaded) return; preloaded = true;
        tour.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      }
      function set(p) {
        var x = Math.min(n - 0.0001, Math.max(0, p * n));
        var idx = Math.floor(x), t = x - idx;
        if (idx !== last) {
          shots.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); s.classList.toggle('is-past', i < idx); });
          texts.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); s.classList.toggle('is-past', i < idx); });
          last = idx;
        }
        if (shots[idx]) shots[idx].style.setProperty('--t', t.toFixed(3));
        ticks.forEach(function (k, i) {
          k.classList.toggle('is-active', i === idx); k.classList.toggle('is-done', i < idx);
          k.querySelector('i').style.setProperty('--fill', i < idx ? 1 : i === idx ? t.toFixed(3) : 0);
        });
      }
      if (reduce) { preload(); set(0); return; }
      var ticking = false;
      var onScroll = function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var r = tour.getBoundingClientRect(), total = tour.offsetHeight - window.innerHeight;
          if (r.top < window.innerHeight * 2.5) preload();
          set(total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0);
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    });

    /* ---------- STAT STRIP COUNT-UP ---------- */
    var stats = Array.prototype.slice.call(document.querySelectorAll('.ls-stat__v')).filter(function (el) {
      var m = el.textContent.trim().match(/^(\d+(?:\.\d+)?)(.*)$/);
      if (!m) return false;
      el.setAttribute('data-ls-count', m[1]); el.setAttribute('data-ls-suffix', m[2]);
      return true;
    });
    onView(stats, countUp);

    /* ---------- COUNTDOWN ---------- */
    document.querySelectorAll('[data-ls-clock]').forEach(function (clock) {
      var end = parseInt(clock.getAttribute('data-ls-clock'), 10) * 1000, u = {};
      clock.querySelectorAll('[data-u]').forEach(function (b) { u[b.getAttribute('data-u')] = b; });
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var s = Math.floor(Math.max(0, end - Date.now()) / 1000);
        u.d.textContent = pad(Math.floor(s / 86400)); u.h.textContent = pad(Math.floor(s % 86400 / 3600));
        u.m.textContent = pad(Math.floor(s % 3600 / 60)); u.s.textContent = pad(s % 60);
      }
      tick(); setInterval(tick, 1000);
    });

    /* ---------- keep everything in sync with the buy box ---------- */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('variant-picker[context="main_product"]') && t.checked && t.value !== current) selectBuild(t.value, true);
    });
    var checked = Array.prototype.filter.call(mainInputs(), function (i) { return i.checked; })[0];
    if (checked) selectBuild(checked.value, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
